import { createSlice, current } from '@reduxjs/toolkit';
import {
	getScreenList,
	addNewScreen,
	updateScreen,
	deleteScreen,
	getScreen,

	getPageList,
	addNewPage,
	updatePage,
	deletePage,
	getPage,

	getPageTypeList,
	addNewPageType,
	updatePageType,
	deletePageType,
	getPageType,

	getGraphList,
	addNewGraph,
	updateGraph,
	deleteGraph,
	getGraph,

	getReportTemplateList,
	addNewReportTemplate,
	updateReportTemplate,
	deleteReportTemplate,
	getReportTemplate,
} from '../screen/thunk';

export const initialState = {
	itemScreenList: [],
	itemScreenDetail: null,
	isScreenLoading: false,
	isScreenSuccess: false,

	itemPageList: [],
	itemPageDetail: null,
	isPageLoading: false,
	isPageSuccess: false,

	itemPageTypeList: [],
	itemPageTypeDetail: null,
	isPageTypeLoading: false,
	isPageTypeSuccess: false,

	itemGraphList: [],
	itemGraphDetail: null,
	isGraphLoading: false,
	isGraphSuccess: false,

	itemReportTemplateList: [],
	itemReportTemplateDetail: null,
	isReportTemplateLoading: false,
	isReportTemplateSuccess: false,

	screenList: [],
	screenListSelect: [],
	pageList: [],
	pageListSelect: [],
	pageTypeList: [],
	pageTypeListSelect: [],
	graphList: [],
	graphListSelect: [],
	reportList: [],
	reportListSelect: [],
	reportList: [],
	reportListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ScreenSlice = createSlice({
	name: 'Screen',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getScreen.fulfilled, (state, action) => {
			state.isScreenLoading = false;
			state.isScreenSuccess = true;
			state.itemScreenDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getScreen.pending, state => {
			state.isScreenLoading = true;
			state.isScreenSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getScreen.rejected, (state, action) => {
			state.isScreenLoading = false;
			state.isScreenSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(getScreenList.fulfilled, (state, action) => {
			state.screenList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getScreenList.pending, state => {
			state.isLoadingList = true;
		});
		builder.addCase(getScreenList.rejected, (state, action) => {
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(addNewScreen.fulfilled, (state, action) => {
			state.isAdding = false;
			state.isAdded = true;
			state.screenList.push(action.payload);
		});
		builder.addCase(addNewScreen.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewScreen.rejected, state => {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
		builder.addCase(updateScreen.fulfilled, (state, action) => {
			state.isUpdating = false;
			state.isUpdated = true;
			const index = state.screenList.findIndex(
				screen => screen.id === action.payload.id
			);
			state.screenList[index] = action.payload;
		});
		builder.addCase(updateScreen.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateScreen.rejected, state => {
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});
		builder.addCase(deleteScreen.fulfilled, (state, action) => {
			state.isDeleting = false;
			state.isDeleted = true;
			state.screenList = state.screenList.filter(
				screen => screen.id !== action.payload.id
			);
		});
		builder.addCase(deleteScreen.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deleteScreen.rejected, state => {
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});



		builder.addCase(getPage.fulfilled, (state, action) => {
			state.isPageLoading = false;
			state.isPageSuccess = true;
			state.itemPageDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPage.pending, state => {
			state.isPageLoading = true;
			state.isPageSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPage.rejected, (state, action) => {
			state.isPageLoading = false;
			state.isPageSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(getPageList.fulfilled, (state, action) => {
			state.pageList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPageList.pending, state => {
			state.isLoadingList = true;
		});
		builder.addCase(getPageList.rejected, (state, action) => {
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(addNewPage.fulfilled, (state, action) => {
			state.isAdding = false;
			state.isAdded = true;
			state.pageList.push(action.payload);
		});
		builder.addCase(addNewPage.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPage.rejected, state => {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
		builder.addCase(updatePage.fulfilled, (state, action) => {
			state.isUpdating = false;
			state.isUpdated = true;
			const index = state.pageList.findIndex(
				page => page.id === action.payload.id
			);
			state.pageList[index] = action.payload;
		});
		builder.addCase(updatePage.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updatePage.rejected, state => {
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});
		builder.addCase(deletePage.fulfilled, (state, action) => {
			state.isDeleting = false;
			state.isDeleted = true;
			state.pageList = state.pageList.filter(
				page => page.id !== action.payload.id
			);
		});
		builder.addCase(deletePage.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deletePage.rejected, state => {
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});



		builder.addCase(getPageType.fulfilled, (state, action) => {
			state.isPageTypeLoading = false;
			state.isPageTypeSuccess = true;
			state.itemPageTypeDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPageType.pending, state => {
			state.isPageTypeLoading = true;
			state.isPageTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPageType.rejected, (state, action) => {
			state.isPageTypeLoading = false;
			state.isPageTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(getPageTypeList.fulfilled, (state, action) => {
			state.pageTypeList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPageTypeList.pending, state => {
			state.isLoadingList = true;
		});
		builder.addCase(getPageTypeList.rejected, (state, action) => {
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(addNewPageType.fulfilled, (state, action) => {
			state.isAdding = false;
			state.isAdded = true;
			state.pageTypeList.push(action.payload);
		});
		builder.addCase(addNewPageType.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPageType.rejected, state => {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
		builder.addCase(updatePageType.fulfilled, (state, action) => {
			state.isUpdating = false;
			state.isUpdated = true;
			const index = state.pageTypeList.findIndex(
				pageType => pageType.id === action.payload.id
			);
			state.pageTypeList[index] = action.payload;
		});
		builder.addCase(updatePageType.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updatePageType.rejected, state => {
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});
		builder.addCase(deletePageType.fulfilled, (state, action) => {
			state.isDeleting = false;
			state.isDeleted = true;
			state.pageTypeList = state.pageTypeList.filter(
				pageType => pageType.id !== action.payload.id
			);
		});
		builder.addCase(deletePageType.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deletePageType.rejected, state => {
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});



		builder.addCase(getGraph.fulfilled, (state, action) => {
			state.isGraphLoading = false;
			state.isGraphSuccess = true;
			state.itemGraphDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getGraph.pending, state => {
			state.isGraphLoading = true;
			state.isGraphSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getGraph.rejected, (state, action) => {
			state.isGraphLoading = false;
			state.isGraphSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(getGraphList.fulfilled, (state, action) => {
			state.graphList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getGraphList.pending, state => {
			state.isLoadingList = true;
		});
		builder.addCase(getGraphList.rejected, (state, action) => {
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(addNewGraph.fulfilled, (state, action) => {
			state.isAdding = false;
			state.isAdded = true;
			state.graphList.push(action.payload);
		});
		builder.addCase(addNewGraph.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewGraph.rejected, state => {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
		builder.addCase(updateGraph.fulfilled, (state, action) => {
			state.isUpdating = false;
			state.isUpdated = true;
			const index = state.graphList.findIndex(
				graph => graph.id === action.payload.id
			);
			state.graphList[index] = action.payload;
		});
		builder.addCase(updateGraph.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateGraph.rejected, state => {
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});
		builder.addCase(deleteGraph.fulfilled, (state, action) => {
			state.isDeleting = false;
			state.isDeleted = true;
			state.graphList = state.graphList.filter(
				graph => graph.id !== action.payload.id
			);
		});
		builder.addCase(deleteGraph.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deleteGraph.rejected, state => {
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});



		builder.addCase(getReportTemplate.fulfilled, (state, action) => {
			state.isReportTemplateLoading = false;
			state.isReportTemplateSuccess = true;
			state.itemReportTemplateDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getReportTemplate.pending, state => {
			state.isReportTemplateLoading = true;
			state.isReportTemplateSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getReportTemplate.rejected, (state, action) => {
			state.isReportTemplateLoading = false;
			state.isReportTemplateSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(getReportTemplateList.fulfilled, (state, action) => {
			state.reportTemplateList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getReportTemplateList.pending, state => {
			state.isLoadingList = true;
		});
		builder.addCase(getReportTemplateList.rejected, (state, action) => {
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(addNewReportTemplate.fulfilled, (state, action) => {
			state.isAdding = false;
			state.isAdded = true;
			state.reportTemplateList.push(action.payload);
		});
		builder.addCase(addNewReportTemplate.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewReportTemplate.rejected, state => {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
		builder.addCase(updateReportTemplate.fulfilled, (state, action) => {
			state.isUpdating = false;
			state.isUpdated = true;
			const index = state.reportTemplateList.findIndex(
				reportTemplate => reportTemplate.id === action.payload.id
			);
			state.reportTemplateList[index] = action.payload;
		});
		builder.addCase(updateReportTemplate.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateReportTemplate.rejected, state => {
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});
		builder.addCase(deleteReportTemplate.fulfilled, (state, action) => {
			state.isDeleting = false;
			state.isDeleted = true;
			state.reportTemplateList = state.reportTemplateList.filter(
				reportTemplate => reportTemplate.id !== action.payload.id
			);
		});
		builder.addCase(deleteReportTemplate.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deleteReportTemplate.rejected, state => {
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});
	},
});

export const { setRequireCloseModal } = ScreenSlice.actions;

export default ScreenSlice.reducer;
